import { setIsAddVisible, setEditingMode } from '../../PromoAdd/actions';
import { connect } from 'react-redux';

const mapDispatchToProps = { setEditingMode, setIsAddVisible };

export default connect(
  undefined,
  mapDispatchToProps
);
